import { defineStore } from 'pinia'
import { ref, computed, markRaw } from 'vue'

let uid = 0

export const useModalStore = defineStore('modal', () => {
  const modals = ref([])

  const top = computed(() => modals.value[modals.value.length - 1] || null)
  const isOpen = computed(() => modals.value.length > 0)

  function open(options) {
    const id = ++uid
    const promise = new Promise((resolve) => {
      modals.value.push({
        id,
        title: options.title ?? 'Modal',
        kind: options.kind ?? 'custom',
        message: options.message ?? '',
        component: options.component ? markRaw(options.component) : null,
        props: options.props ?? {},
        confirmText: options.confirmText ?? 'OK',
        cancelText: options.cancelText ?? 'Annuler',
        showConfirm: options.showConfirm ?? true,
        showCancel: options.showCancel ?? (options.kind === 'confirm'),
        dismissible: options.dismissible ?? true,
        closeOnEsc: options.closeOnEsc ?? true,
        closeOnBackdrop: options.closeOnBackdrop ?? true,
        maxWidth: options.maxWidth ?? '700px',
        loading: false,
        onConfirm: options.onConfirm ?? null,
        resolve,
      })

      // if (modals.value.length === 1) {
      //   document.body.style.overflow = 'hidden'
      // }
    })

    // ✅ RETOURNER un objet avec l'id ET la promise
    return {
      id,           // Pour pouvoir fermer programmatiquement
      result: promise,  // La promise qui résout quand la modal se ferme
      close: () => close(id),  // Raccourci pour fermer
      cancel: () => cancel(id) // Raccourci pour annuler
    }
  }

  function _close(id, payload) {
    const idx = modals.value.findIndex(x => x.id === id)
    if (idx === -1) return
    const m = modals.value[idx]
    modals.value.splice(idx, 1)

    // if (modals.value.length === 0) {
    //   document.body.style.overflow = ''
    // }

    m.resolve(payload)
  }

  function close(id) { _close(id, { action: 'close' }) }
  function cancel(id) { _close(id, { action: 'cancel' }) }

  async function confirm(id) {
    const m = modals.value.find(x => x.id === id)
    if (!m) return

    if (m.onConfirm) {
      m.loading = true
      try {
        await m.onConfirm()
        _close(id, { action: 'confirm' })
      } catch (error) {
        console.error('Erreur:', error)
        m.loading = false
      }
    } else {
      _close(id, { action: 'confirm' })
    }
  }

  function submit(id, data) { _close(id, { action: 'submit', data }) }

  // Helpers
  function alert(title, message) {
    return open({ kind: 'alert', title, message, showCancel: false })
  }

  function confirmDialog(title, message, onConfirm) {
    return open({ kind: 'confirm', title, message, onConfirm })
  }

  function openComponent(component, props, opts = {}) {
    return open({ kind: 'custom', component, props, ...opts })
  }

  // 🎯 Helper pour modal de chargement (optionnel)
  function loading(title = 'Chargement...', message = 'Veuillez patienter...') {
    return open({
      kind: 'alert',
      title,
      message,
      showConfirm: false,
      showCancel: false,
      dismissible: true,
      closeOnBackdrop: false,
      closeOnEsc: true
    })
  }

  return {
    modals, top, isOpen,
    open, alert, confirmDialog, openComponent, loading,
    close, cancel, confirm, submit
  }
})
